import _regeneratorRuntime from "/var/jenkins_home/workspace/bieyang_home/by-home/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import React from 'react';
import { mergeProps } from '../../utils/with-default-props';
import classNames from 'classnames';
import Mask from '../mask';
import { DialogActionButton } from './dialog-action-button';
import Image from '../image';
import Space from '../space';
var classPrefix = "adm-dialog";
var defaultProps = {
  actions: [],
  closeOnAction: false,
  closeOnMaskClick: false
};
export var Dialog = function Dialog(p) {
  var props = mergeProps(defaultProps, p);
  return /*#__PURE__*/React.createElement(Mask, {
    visible: props.visible,
    destroyOnClose: true,
    getContainer: props.getContainer,
    afterClose: props.afterClose,
    onMaskClick: props.closeOnMaskClick ? props.onClose : undefined,
    style: props.maskStyle,
    className: classNames(classPrefix + "-mask", props.maskClassName)
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    className: classPrefix + "-wrap"
  }, !!props.image && /*#__PURE__*/React.createElement(Image, {
    src: props.image,
    alt: 'dialog header image',
    width: '100%'
  }), /*#__PURE__*/React.createElement("div", {
    style: props.bodyStyle,
    className: classNames(classPrefix + "-body", props.bodyClassName)
  }, /*#__PURE__*/React.createElement(Space, {
    direction: 'vertical',
    block: true
  }, !!props.header && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-body-header-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-body-header"
  }, props.header)), !!props.title && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-body-title"
  }, props.title), !!props.content && /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-body-message-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-body-message"
  }, props.content)))), /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-footer"
  }, props.actions.map(function (row, index) {
    var actions = Array.isArray(row) ? row : [row];
    return /*#__PURE__*/React.createElement("div", {
      className: classPrefix + "-action-row",
      key: index
    }, actions.map(function (action, index) {
      return /*#__PURE__*/React.createElement(DialogActionButton, {
        key: action.key,
        action: action,
        onAction: function onAction() {
          return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var _a, _b;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return (_a = props.onAction) === null || _a === void 0 ? void 0 : _a.call(props, action, index);

                  case 2:
                    if (props.closeOnAction) {
                      (_b = props.onClose) === null || _b === void 0 ? void 0 : _b.call(props);
                    }

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
        }
      });
    }));
  }))));
};